import api from "../services/apiService";
import { addUserLog } from "./utilityController"; // Adjust path if needed

export const loginUser = async (email, password) => {
  try {
    const response = await api.post("/users/login", { email, password });

    if (response.data?.token) {
      localStorage.setItem("token", response.data.token);
      api.defaults.headers.common["Authorization"] = `Bearer ${response.data.token}`;

      // Log user activity after successful login
      try {
        await addUserLog("User logged in");
      } catch (logError) {
        console.warn("Login successful but failed to log activity:", logError);
      }

      return { success: true, token: response.data.token };
    } else {
      return { success: false, message: "Unexpected response from server" };
    }

  } catch (err) {
    console.error(err);
    return { success: false, message: err.response?.data?.message || "Login failed" };
  }
};
